/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../config/config";
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import axios from "axios";
import IndirectTaxBarChart from "./IndirectTaxBarChart/IndirectTaxBarChart";
import IndirectTaxPieChart from "./IndirectTaxPieChart/IndirectTaxPieChart";
import DepartmentBarChart from "./DepartmentBarChart/DepartmentBarChart";
import DashboardSection from "../DashboardContainer/DashboardSection";
import DetailedDomainTile from "../../atomicComponents/DetailedDomainTile/DetailedDomainTile";
import styles from "./IndirectTaxMainDashboard.module.css";
import "./IndirectTaxMainDashboard.css";
// import HorizentalTileCardDual from "../ProcureToPayComp/DualCircleCards/HorizentalCard";

const weekOptions = [
  { value: "undefined", label: "Select" },
  { value: "All", label: "-All-" },
  { value: "Week-1", label: "Week-1" },
  { value: "Week-2", label: "Week-2" },
  { value: "Week-3", label: "Week-3" },
  { value: "Week-4", label: "Week-4" },
];

const { API_BASE_URL } = config;

const IndirectTaxMainDashboard = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();

  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    entityData: [],
    yearData: [],
    monthData: [],
    weekData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [week, setWeek] = useState(weekOptions[0]);

  const [gstFilingTimelinessData, setGstFilingTimelinessData] = useState([]);
  const [gstFilingData, setGstFilingData] = useState([]);
  const [gstComplianceData, setGstComplianceData] = useState([]);
  const [penaltiesData, setPenaltiesData] = useState([]);
  const [departmentalData, setDepartmentalData] = useState([]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "20px",
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: "visible",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }),
    option: (provided) => ({
      ...provided,
      padding: "8px 12px",
    }),
  };

  const handleEntityChange = (selected) => {
    const updatedEntity = selected || [];
    setEntity(updatedEntity);
    setFilters((prev) => ({ ...prev, entityData: updatedEntity }));
  };

  const handleYearChange = (selected) => {
    const updatedYear = selected || [];
    setYear(updatedYear);
    setFilters((prev) => ({ ...prev, yearData: updatedYear }));
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters((prev) => ({ ...prev, monthData: updatedMonths }));
  };

  const handleWeekChange = (selected) => {
    setWeek(selected);
    setFilters(prev => ({ ...prev, weekData: selected }));
  };

  const handleApply = () => {
    const entityFilterData = entity?.map((e) => e?.value) || [];
    const yearFilterData = year?.map((y) => y?.value) || [];
    const monthFilterData = month?.map((m) => m?.value) || [];

    if (!entityFilterData || entityFilterData.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    setIsLoading(true);

    const fetchGstFilingTimelinessData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/idt-gstfilingtimeliness`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setGstFilingTimelinessData(result.filingtimeliness || []);
          })
      } catch (error) {
        console.error('Error fetching IDT GST Filing Timeliness options:', error);
      }
    };

    const fetchGstFilingStatusData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/idt-gstfilingstatus`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            if (result.filingstatus && result.filingstatus.length > 0) {
              const filing = result.filingstatus[0];
              setGstFilingData({
                totalFilings: filing.total_filings || 0,
                completed: filing.completed || 0,
                pending: filing.pending || 0,
              });
            }
          })
      } catch (error) {
        console.error('Error fetching IDT GST Filing Status options:', error);
      }
    };

    const fetchGstComplianceData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/idt-gstcompliance`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setGstComplianceData(result.compliance || []);
          })
      } catch (error) {
        console.error('Error fetching IDT GST Compliance options:', error);
      }
    };

    const fetchPenaltiesData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/idt-penalties`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            const penalties = result.penalties || [];

            const penaltiesData = penalties.map(item => ({
              label: item.gstr_compliance,
              value: item.interest_late_fee ? Number(item.interest_late_fee) : 0,
            }));

            setPenaltiesData(penaltiesData);
          })
      } catch (error) {
        console.error('Error fetching IDT Penalties options:', error);
      }
    };

    const fetchDepartmentalNotice = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/idt-departmental`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            const departmental = result.departmental || [];

            if (departmental.length > 0) {
              const row = departmental[0];
              const chartData = [
                { label: "Open", value: row.Open },
                { label: "In Progress", value: row.In_Progress },
                { label: "Completed", value: row.Completed },
              ];
              setDepartmentalData(chartData);
            } else {
              setDepartmentalData([]);
            }
          })
      } catch (error) {
        console.error('Error fetching IDT Departmental options:', error);
      }
    };

    Promise.all([fetchGstFilingTimelinessData(), fetchGstFilingStatusData(), fetchGstComplianceData(), fetchPenaltiesData(), fetchDepartmentalNotice()]).then(() => {
      setShowDashboard(true);
      setIsLoading(false);
    });
  };

  const handleReset = () => {
    setEntity([]);
    setYear([]);
    setMonth([]);
    setWeek(weekOptions[0]);
    setFilters({
      entityData: [],
      yearData: [],
      monthData: [],
      weekData: [],
    });
    setShowDashboard(false);
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/idt-entity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setEntityOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching idt-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/idt-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching idt-year options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/idt-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setMonthOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching idt-month options:', error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    fetchMonthOptions();
  }, []);

  useEffect(() => {
    if (entityOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.entityData && filters.entityData.length > 0) {
        const ent = entityOptions.filter((opt) =>
          filters.entityData.some((e) => e.value === opt.value)
        );
        if (ent.length > 0) setEntity(ent);
      }

      if (filters.yearData && filters.yearData.length > 0) {
        const yr = yearOptions.filter((opt) =>
          filters.yearData.some((y) => y.value === opt.value)
        );
        if (yr.length > 0) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter((opt) =>
          filters.monthData.some((m) => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.entityData && filters.entityData.length > 0) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          {/* <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Week</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={week}
                onChange={setWeek}
                options={weekOptions}
                isSearchable={true}
                styles={customStyles}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div> */}
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
          </div>
        </div>
      )}
      {showDashboard && (
        <>
          <div>
            <div className="row">
              <div className="col-lg-8">
                <DetailedDomainTile
                  title="GST Returns Filing and Compliance"
                  showButton={true}
                  path="/Indirect-Tax/GST-Return-Filing-Compliance-Penalties"
                  detailState={filters}
                   infoIcondata={"Manual CSV DATA"}
                />
                <div className="row">
                  <div className="col-lg-6 mt-2">
                    <div className="row">
                      <div className="col-lg-12 mb-2">
                        <DashboardSection
                          title="GST Filing Timeliness"
                          disableDetailView={true}
                        >
                          <div className={styles.tableWrapper}>
                            <table className={styles.customTable}>
                              <thead>
                                <tr>
                                  <th>GSTR</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {gstFilingTimelinessData.map((item, index) => (
                                  <tr key={index}>
                                    <td className={styles.blue_col}>{item.GSTR}</td>
                                    {/* <td
                                      className={
                                        item.Status === "On Time" ? styles.green_col
                                          : item.Status === "Delayed" ? styles.red_col
                                            : styles.grey_col
                                      }
                                    >
                                      {item.Status === "On Time" && "✔️ "}
                                      {item.Status === "Delayed" && "⏰ "}
                                      {item.Status === "Not Applicable" && "🚫"}

                                      {item.Status}
                                    </td> */}

                                    <td
                                      style={{
                                        height: "20px",
                                        // border: "none",
                                      }}
                                    >
                                      <div
                                        style={{
                                          borderRadius: "10px",
                                          color: "black",
                                          width: "120px",
                                          fontSize: "14px",
                                          paddingTop: "5px",
                                          background:
                                            item.Status === "On Time"
                                              ? "#73ea79"
                                              : item.Status === "Delayed"
                                                ? "yellow"
                                                : item.Status === "Not Applicable"
                                                  ? "#ff8900"
                                                  : "grey", // default
                                          color: item.Status === "Delayed" ? "black" : "black", // better contrast
                                          marginLeft: "30px",
                                          height: "40px",
                                                                                  boxShadow: `
                                                  2px 2px 5px rgba(0,0,0,1),   /* shadow bottom-right */
                                                  -2px -2px 5px rgba(255,255,255,1) /* highlight top-left */
                                                `,
                                        }}
                                      >
                                        {item.Status === "On Time" && "✔️ "}
                                        {item.Status === "Delayed" && "⏰ "}
                                        {item.Status === "Not Applicable" && "🚫 "}
                                        {item.Status}
                                      </div>
                                    </td>

                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </DashboardSection>
                      </div>
                      <div className="col-lg-12">
                        <DashboardSection
                          title="GST Filing Status"
                          disableDetailView={true}
                        >
                          <div className={styles.tableWrapper}>
                            <table className={styles.newCustomTable}>
                              <thead>
                                <tr>
                                  <th>Total Filings</th>
                                  <th>Completed</th>
                                  <th>Pending</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{gstFilingData.totalFilings}</td>
                                  <td>{gstFilingData.completed}</td>
                                  <td>{gstFilingData.pending}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <br></br>
                          <IndirectTaxPieChart Completed={gstFilingData.completed} Pending={gstFilingData.pending} />
                          {/* <HorizentalTileCardDual
                            title="VQA & ETCG"
                            Completed={gstFilingData.completed ?? 0}
                            Pending={gstFilingData.pending ?? 0}
                            color1="#800080"
                            color2="#21cf21"
                          /> */}
                        </DashboardSection>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 mt-2">
                    <DashboardSection
                      title="GST Compliance"
                      disableDetailView={true}
                    >
                      <div className="col-lg-12">
                        <div className={styles.compTableWrapper}>
                          <table className={styles.compCustomTable}>
                            <thead>
                              <tr style={{ height: "40px" }}>
                                <th>Compliance List</th>
                                <th>Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {gstComplianceData.map((item, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    minHeight: "30px",
                                    height: "10px",
                                  }}
                                >
                                  {/* Compliance — auto height */}
                                  <td
                                    className={styles.blue_col}
                                    style={{
                                      padding: "6px 5px",
                                      fontSize: "13px",
                                      verticalAlign: "middle",
                                      lineHeight: "16px",
                                      whiteSpace: "normal"
                                    }}
                                  >
                                    {item.Compliance}
                                  </td>

                                  {/* STATUS — fixed height */}

                                  <td
                                    style={{
                                      height: "20px",
                                      // border: "none",
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "30px",
                                        // maxWidth:'140px',
                                        borderRadius: "10px",
                                        color: "white",
                                        width: "125px",
                                        fontSize: "14px",
                                        // fontWeight:'bold',
                                        paddingTop: "5px",
                                        background:
                                          item.Status === "On Time"
                                            ? "#73ea79"
                                            : item.Status === "Delayed"
                                              ? "yellow"
                                              : item.Status === "Not Applicable"
                                                ? "#ff8900"
                                                : "grey", // default
                                        color: item.Status === "Delayed" ? "black" : "black", // better contrast
                                        boxShadow: `
                                                  2px 2px 5px rgba(0,0,0,1),   /* shadow bottom-right */
                                                  -2px -2px 5px rgba(255,255,255,1) /* highlight top-left */
                                                `,
                                      }}
                                    >
                                      {item.Status === "On Time" && "✔️ "}
                                      {item.Status === "Delayed" && "⏰ "}
                                      {item.Status === "Not Applicable" && "🚫 "}
                                      {item.Status}
                                    </div>
                                  </td>





                                </tr>


                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </DashboardSection>
                  </div>



                </div>
              </div>
              <div className="col-lg-4">
                <DetailedDomainTile title="Penalties" showButton={false} infoIcondata={"Manual CSV DATA"}/>
                <div className="mt-2">
                  <DashboardSection
                    title="Interest Paid / Late Fee (in ₹ Crores)"
                    disableDetailView={true}
                     
                  >
                    <IndirectTaxBarChart data={penaltiesData} />
                  </DashboardSection>
                </div>
                <div className="row">
                  <div className="col-lg-12 mt-2">
                    <DetailedDomainTile
                      title="Departmental Notices"
                      showButton={true}
                      path="/Indirect-Tax/Departmental-Notices"
                      detailState={filters}
                       infoIcondata={"Manual CSV DATA"}
                    />
                    <div className="mt-1">
                      <DashboardSection disableDetailView={true}>
                        <DepartmentBarChart data={departmentalData} />
                      </DashboardSection>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default IndirectTaxMainDashboard;